export default __webpack_public_path__ + "static/media/element_62.a64241c2.jpg";